module.exports = __webpack_public_path__ + "img/manifestation-journal_B09PX7W96T.7684b918.jpg";